import { Web3RecordItemModel } from '@/services/apis/txRecord/models'
import styles from './index.module.scss'

import React, { memo, useEffect, useState } from 'react'
import { useTranslation } from '@/services/i18n'
import cls from 'classnames'
import { formatUnits } from 'ethers'

interface ChildProp {
  records: Web3RecordItemModel
}

const Web3ExpandRow = memo<ChildProp>(props => {
  const { t } = useTranslation()
  const { records } = props

  const [isVisualData, setIsVisualData] = useState(false)
  function transaction() {
    if (!records.transaction?.visualData) {
      setIsVisualData(false)
    } else {
      setIsVisualData(true)
    }
  }
  function showRight() {
    if (records.subjectType === 'eth_signTransaction') {
      if (
        records.subjectSubType === 'contract_deploy' ||
        records.subjectSubType === 'nft_transfer' ||
        records.subjectSubType === 'token_transfer'
      ) {
        return false
      }
      if (!records.transaction?.data) {
        return false
      }
    }
    return true
  }
  function changeVisual(bo: boolean) {
    setIsVisualData(bo)
  }
  function formatBalance(unit: string, decimals: number) {
    const UNLIMITED_AMOUNT = BigInt('0x' + new Array(64).fill('f').join('')).toString()
    if (unit === UNLIMITED_AMOUNT) {
      return t('record.setApproval')
    }
    return formatUnits(unit, decimals).toString()
  }

  useEffect(() => {
    transaction()
  }, [])

  return (
    <div className={styles.web3ExpandRow}>
      <div className={styles.left}>
        {/* 从 */}
        <div className={styles.textLabel}>
          <div className={styles.label}>{t('record.from')}:</div>
          <div className={styles.desc}>
            {`${records.sourceAccountName} (${records.sourceAddress})`}
          </div>
        </div>

        {/* 到 */}
        {records.subjectType === 'eth_signTransaction' && (
          <div className={styles.textLabel}>
            <div className={styles.label}>
              {[
                'native_transfer',
                'token_transfer',
                'approve',
                'contract_unknown_invoke',
                'nft_transfer',
              ].includes(records.subjectSubType)
                ? t('record.to')
                : t('record.authorize')}
              :
            </div>
            {records.transaction && (
              <div className={styles.desc}>
                {records.subjectSubType === 'native_transfer' ||
                records.subjectSubType === 'token_transfer'
                  ? records.extraData.toAddress !== null
                    ? records.extraData.toAddress
                    : records.transaction.to
                  : records.contractAddress}
              </div>
            )}
          </div>
        )}
        {/* 网络 */}
        {(records.subjectType === 'eth_signTypedData' ||
          records.subjectType === 'eth_signTransaction') && (
          <div className={styles.textLabel}>
            <div className={styles.label}>{t('record.network')}:</div>
            <div className={styles.desc}>{records.networkName}</div>
          </div>
        )}
        {records.subjectType === 'eth_signTransaction' && (
          <div className={styles.textLabel}>
            <div className={styles.label}>{t('record.SignatureRes')} hash:</div>
            {records.transaction && <div className={styles.desc}>{records.txHash || ''}</div>}
          </div>
        )}
        {records.transactionStatus !== '0' && (
          <div className={styles.textLabel}>
            <div className={styles.label}>{t('record.subState')}:</div>
            <div className={styles.desc}>{records.transactionSubStatusDesc}</div>
          </div>
        )}
        {records.note && (
          <div className={styles.textLabel}>
            <div className={styles.label}>{t('common.remark')}:</div>
            <div className={styles.desc}>{records.note}</div>
          </div>
        )}
      </div>
      {showRight() && (
        <div className={styles.right}>
          {records.subjectType === 'personal_sign' && (
            <div className={styles.item}>
              <div className={styles.label}>{t('record.message')}:</div>
              <div className={styles.mesBox}>
                <div className={cls([styles.message, styles.textarea])}>{records.message}</div>
              </div>
            </div>
          )}
          {records.subjectType === 'eth_signTypedData' && (
            <div className={styles.item}>
              <div className={styles.label}>{t('record.information')}:</div>
              <div className={styles.mesBox}>
                <div className={cls([styles.message, styles.textarea])}>{records.message}</div>
              </div>
            </div>
          )}
          {records.subjectType === 'eth_sign' && (
            <div className={styles.item}>
              <div className={styles.label}>{t('record.message')}:</div>
              {records.messageHash && (
                <div className={styles.mesBox}>{records.messageHash[0].hash}</div>
              )}
            </div>
          )}
          {records.subjectType === 'eth_signTransaction' && (
            <div>
              {records.subjectSubType === 'native_transfer' && (
                <div className={styles.item}>
                  <div className={styles.label}>{t('record.hexData')}:</div>
                  {records.transaction && (
                    <div className={styles.mesBox}>{records.transaction.data}</div>
                  )}
                </div>
              )}
              {records.subjectSubType === 'approve' && (
                <div className={styles.item}>
                  <div className={styles.label}>{t('record.AuthorizedAmount')}:</div>
                  <div className={styles.mesBox}>
                    {formatBalance(records.extraData.approveValue, records.decimals)}
                    {records.tokenSymbol}
                  </div>
                </div>
              )}
              {records.subjectSubType === 'approve' ||
              records.subjectSubType === 'native_transfer' ? null : (
                <div className={styles.item}>
                  <div className={styles.label}>
                    {isVisualData ? t('record.data') : t('record.hexData')}:
                  </div>
                  {records.transaction && (
                    <div className={styles.mesBox}>
                      {isVisualData && records.transaction.visualData ? (
                        <div
                          className={cls([styles.message, styles.textarea])}
                          style={{ height: '126px' }}
                        >
                          Function: {records.transaction.visualData.method} <br />
                          <br />
                          MethodID: {records.transaction.visualData.rawParameters[0]}
                          <br />
                          {records.transaction.visualData.rawParameters
                            .slice(1)
                            .map((item, index) => {
                              return (
                                <p key={index}>
                                  [{index}]:
                                  <br />
                                  {item}
                                  <br />
                                  <br />
                                </p>
                              )
                            })}
                        </div>
                      ) : (
                        <div
                          className={cls([styles.message, styles.textarea])}
                          style={{ height: '126px' }}
                        >
                          {records.transaction.data}
                        </div>
                      )}
                      {records.transaction.visualData && (
                        <div className={styles.switchBtn}>
                          <div
                            className={cls({ [styles.active]: isVisualData })}
                            onClick={() => changeVisual(true)}
                          >
                            {t('record.default')}
                          </div>
                          <div
                            className={cls({ [styles.active]: !isVisualData })}
                            onClick={() => changeVisual(false)}
                          >
                            {t('record.hex')}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
})

export default Web3ExpandRow
